import DocumentNew from './DocumentNew'

export default DocumentNew
// eslint-disable-next-line import/export
export * from './DocumentNew'
